<div *ngIf="getList().isNotEmpty()">
  <h2 i18n="@@scannedMenu">Scanned Menu</h2>
  <div class="horizontal-scroll">
    <ul class="list-container">
      <div *ngFor="let item of getList()">
        <img (click)="openURLInNewTab(item)" [src]="getImageSrc(item)" class="menu-image">
      </div>
    </ul>
  </div>
</div>
